module.exports = __webpack_public_path__ + "media/images/default-question-6d0cc00e56af989a1d8219dd570aa0e7.svg";